// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as User$FeedSync from "./models/User.bs.mjs";
import * as Settings$FeedSync from "./Settings.bs.mjs";
import * as SnapshotTrackerId$FeedSync from "./SnapshotTrackerId.bs.mjs";

function error_encode(v) {
  return Js_dict.fromArray([
              [
                "endTime",
                Decco.floatToJson(v.endTime)
              ],
              [
                "lineNumber",
                Decco.optionToJson(Decco.intToJson, v.lineNumber)
              ],
              [
                "message",
                Decco.stringToJson(v.message)
              ]
            ]);
}

function error_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var endTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endTime"), null));
  if (endTime.TAG === /* Ok */0) {
    var lineNumber = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lineNumber"), null));
    if (lineNumber.TAG === /* Ok */0) {
      var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
      if (message.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  endTime: endTime._0,
                  lineNumber: lineNumber._0,
                  message: message._0
                }
              };
      }
      var e = message._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".message" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = lineNumber._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".lineNumber" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = endTime._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".endTime" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function success_encode(v) {
  return Js_dict.fromArray([[
                "endTime",
                Decco.floatToJson(v.endTime)
              ]]);
}

function success_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var endTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "endTime"), null));
  if (endTime.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              endTime: endTime._0
            }
          };
  }
  var e = endTime._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".endTime" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function issue_encode(v) {
  return Js_dict.fromArray([
              [
                "message",
                Decco.stringToJson(v.message)
              ],
              [
                "firstOccurence",
                Decco.optionToJson(Decco.intToJson, v.firstOccurence)
              ],
              [
                "numOccurences",
                Decco.intToJson(v.numOccurences)
              ]
            ]);
}

function issue_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
  if (message.TAG === /* Ok */0) {
    var firstOccurence = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstOccurence"), null));
    if (firstOccurence.TAG === /* Ok */0) {
      var numOccurences = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numOccurences"), null));
      if (numOccurences.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  message: message._0,
                  firstOccurence: firstOccurence._0,
                  numOccurences: numOccurences._0
                }
              };
      }
      var e = numOccurences._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numOccurences" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = firstOccurence._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".firstOccurence" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = message._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".message" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Curry._1(SnapshotTrackerId$FeedSync.t_encode, v.id)
              ],
              [
                "userId",
                Curry._1(User$FeedSync.Id.t_encode, v.userId)
              ],
              [
                "settings",
                Settings$FeedSync.t_encode(v.settings)
              ],
              [
                "result",
                Decco.optionToJson((function (param) {
                        return Decco.resultToJson(success_encode, error_encode, param);
                      }), v.result)
              ],
              [
                "startTime",
                Decco.floatToJson(v.startTime)
              ],
              [
                "lastUpdatedAt",
                Decco.floatToJson(v.lastUpdatedAt)
              ],
              [
                "issues",
                Decco.arrayToJson(issue_encode, v.issues)
              ],
              [
                "statusMessage",
                Decco.stringToJson(v.statusMessage)
              ],
              [
                "productCount",
                Decco.intToJson(v.productCount)
              ],
              [
                "validProductCount",
                Decco.intToJson(v.validProductCount)
              ],
              [
                "invalidProductCount",
                Decco.intToJson(v.invalidProductCount)
              ],
              [
                "productsWithWarnings",
                Decco.intToJson(v.productsWithWarnings)
              ],
              [
                "reportFailures",
                Decco.boolToJson(v.reportFailures)
              ],
              [
                "downloadedAndStaticCached",
                Decco.boolToJson(v.downloadedAndStaticCached)
              ],
              [
                "fullyDeployed",
                Decco.boolToJson(v.fullyDeployed)
              ],
              [
                "rollbackTime",
                Decco.optionToJson(Decco.floatToJson, v.rollbackTime)
              ],
              [
                "requiresApproval",
                Decco.boolToJson(v.requiresApproval)
              ],
              [
                "resume",
                Decco.boolToJson(v.resume)
              ],
              [
                "_isLive",
                Decco.optionToJson(Decco.boolToJson, v._isLive)
              ],
              [
                "_isLatest",
                Decco.optionToJson(Decco.boolToJson, v._isLatest)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Curry._1(SnapshotTrackerId$FeedSync.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var userId = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "userId"), User$FeedSync.Id.t_decode), {
          TAG: /* Ok */0,
          _0: Curry._1(User$FeedSync.Id.fromString, "-1")
        });
    if (userId.TAG === /* Ok */0) {
      var settings = Settings$FeedSync.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "settings"), null));
      if (settings.TAG === /* Ok */0) {
        var result = Decco.optionFromJson((function (param) {
                return Decco.resultFromJson(success_decode, error_decode, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "result"), null));
        if (result.TAG === /* Ok */0) {
          var startTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startTime"), null));
          if (startTime.TAG === /* Ok */0) {
            var lastUpdatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastUpdatedAt"), null));
            if (lastUpdatedAt.TAG === /* Ok */0) {
              var issues = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "issues"), (function (param) {
                          return Decco.arrayFromJson(issue_decode, param);
                        })), {
                    TAG: /* Ok */0,
                    _0: []
                  });
              if (issues.TAG === /* Ok */0) {
                var statusMessage = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "statusMessage"), Decco.stringFromJson), {
                      TAG: /* Ok */0,
                      _0: ""
                    });
                if (statusMessage.TAG === /* Ok */0) {
                  var productCount = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "productCount"), Decco.intFromJson), {
                        TAG: /* Ok */0,
                        _0: 0
                      });
                  if (productCount.TAG === /* Ok */0) {
                    var validProductCount = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "validProductCount"), Decco.intFromJson), {
                          TAG: /* Ok */0,
                          _0: 0
                        });
                    if (validProductCount.TAG === /* Ok */0) {
                      var invalidProductCount = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "invalidProductCount"), Decco.intFromJson), {
                            TAG: /* Ok */0,
                            _0: 0
                          });
                      if (invalidProductCount.TAG === /* Ok */0) {
                        var productsWithWarnings = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "productsWithWarnings"), Decco.intFromJson), {
                              TAG: /* Ok */0,
                              _0: 0
                            });
                        if (productsWithWarnings.TAG === /* Ok */0) {
                          var reportFailures = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "reportFailures"), Decco.boolFromJson), {
                                TAG: /* Ok */0,
                                _0: false
                              });
                          if (reportFailures.TAG === /* Ok */0) {
                            var downloadedAndStaticCached = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "downloadedAndStaticCached"), Decco.boolFromJson), {
                                  TAG: /* Ok */0,
                                  _0: false
                                });
                            if (downloadedAndStaticCached.TAG === /* Ok */0) {
                              var fullyDeployed = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "fullyDeployed"), Decco.boolFromJson), {
                                    TAG: /* Ok */0,
                                    _0: false
                                  });
                              if (fullyDeployed.TAG === /* Ok */0) {
                                var rollbackTime = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rollbackTime"), null));
                                if (rollbackTime.TAG === /* Ok */0) {
                                  var requiresApproval = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "requiresApproval"), Decco.boolFromJson), {
                                        TAG: /* Ok */0,
                                        _0: false
                                      });
                                  if (requiresApproval.TAG === /* Ok */0) {
                                    var resume = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "resume"), Decco.boolFromJson), {
                                          TAG: /* Ok */0,
                                          _0: false
                                        });
                                    if (resume.TAG === /* Ok */0) {
                                      var _isLive = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "_isLive"), null));
                                      if (_isLive.TAG === /* Ok */0) {
                                        var _isLatest = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "_isLatest"), null));
                                        if (_isLatest.TAG === /* Ok */0) {
                                          return {
                                                  TAG: /* Ok */0,
                                                  _0: {
                                                    id: id._0,
                                                    userId: userId._0,
                                                    settings: settings._0,
                                                    result: result._0,
                                                    startTime: startTime._0,
                                                    lastUpdatedAt: lastUpdatedAt._0,
                                                    issues: issues._0,
                                                    statusMessage: statusMessage._0,
                                                    productCount: productCount._0,
                                                    validProductCount: validProductCount._0,
                                                    invalidProductCount: invalidProductCount._0,
                                                    productsWithWarnings: productsWithWarnings._0,
                                                    reportFailures: reportFailures._0,
                                                    downloadedAndStaticCached: downloadedAndStaticCached._0,
                                                    fullyDeployed: fullyDeployed._0,
                                                    rollbackTime: rollbackTime._0,
                                                    requiresApproval: requiresApproval._0,
                                                    resume: resume._0,
                                                    _isLive: _isLive._0,
                                                    _isLatest: _isLatest._0
                                                  }
                                                };
                                        }
                                        var e = _isLatest._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: "._isLatest" + e.path,
                                                  message: e.message,
                                                  value: e.value
                                                }
                                              };
                                      }
                                      var e$1 = _isLive._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: "._isLive" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                              }
                                            };
                                    }
                                    var e$2 = resume._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".resume" + e$2.path,
                                              message: e$2.message,
                                              value: e$2.value
                                            }
                                          };
                                  }
                                  var e$3 = requiresApproval._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".requiresApproval" + e$3.path,
                                            message: e$3.message,
                                            value: e$3.value
                                          }
                                        };
                                }
                                var e$4 = rollbackTime._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".rollbackTime" + e$4.path,
                                          message: e$4.message,
                                          value: e$4.value
                                        }
                                      };
                              }
                              var e$5 = fullyDeployed._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".fullyDeployed" + e$5.path,
                                        message: e$5.message,
                                        value: e$5.value
                                      }
                                    };
                            }
                            var e$6 = downloadedAndStaticCached._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".downloadedAndStaticCached" + e$6.path,
                                      message: e$6.message,
                                      value: e$6.value
                                    }
                                  };
                          }
                          var e$7 = reportFailures._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".reportFailures" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                  }
                                };
                        }
                        var e$8 = productsWithWarnings._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".productsWithWarnings" + e$8.path,
                                  message: e$8.message,
                                  value: e$8.value
                                }
                              };
                      }
                      var e$9 = invalidProductCount._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".invalidProductCount" + e$9.path,
                                message: e$9.message,
                                value: e$9.value
                              }
                            };
                    }
                    var e$10 = validProductCount._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".validProductCount" + e$10.path,
                              message: e$10.message,
                              value: e$10.value
                            }
                          };
                  }
                  var e$11 = productCount._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".productCount" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                          }
                        };
                }
                var e$12 = statusMessage._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".statusMessage" + e$12.path,
                          message: e$12.message,
                          value: e$12.value
                        }
                      };
              }
              var e$13 = issues._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".issues" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                      }
                    };
            }
            var e$14 = lastUpdatedAt._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".lastUpdatedAt" + e$14.path,
                      message: e$14.message,
                      value: e$14.value
                    }
                  };
          }
          var e$15 = startTime._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".startTime" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
        }
        var e$16 = result._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".result" + e$16.path,
                  message: e$16.message,
                  value: e$16.value
                }
              };
      }
      var e$17 = settings._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".settings" + e$17.path,
                message: e$17.message,
                value: e$17.value
              }
            };
    }
    var e$18 = userId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".userId" + e$18.path,
              message: e$18.message,
              value: e$18.value
            }
          };
  }
  var e$19 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$19.path,
            message: e$19.message,
            value: e$19.value
          }
        };
}

var codec = [
  t_encode,
  t_decode
];

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

var codec$1 = [
  t_encode$1,
  t_decode$1
];

var $$Array = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  codec: codec$1,
  toJson: t_encode$1,
  fromJson: t_decode$1
};

function start(userId, settings, reportFailures, requiresApproval, rollbackTime) {
  var startTime = Date.now();
  var id = Curry._1(SnapshotTrackerId$FeedSync.fromString, "" + Curry._1(User$FeedSync.Id.toString, userId) + "@" + startTime.toFixed() + "");
  return {
          id: id,
          userId: userId,
          settings: settings,
          result: undefined,
          startTime: startTime,
          lastUpdatedAt: startTime,
          issues: [],
          statusMessage: "Starting...",
          productCount: 0,
          validProductCount: 0,
          invalidProductCount: 0,
          productsWithWarnings: 0,
          reportFailures: reportFailures,
          downloadedAndStaticCached: false,
          fullyDeployed: false,
          rollbackTime: rollbackTime,
          requiresApproval: requiresApproval,
          resume: false,
          _isLive: undefined,
          _isLatest: undefined
        };
}

function t_encode$2(v) {
  return Js_dict.fromArray([[
                "reason",
                Decco.stringToJson(v.reason)
              ]]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var reason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "reason"), null));
  if (reason.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              reason: reason._0
            }
          };
  }
  var e = reason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".reason" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var codec$2 = [
  t_encode$2,
  t_decode$2
];

var Interrupt = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  codec: codec$2,
  toJson: t_encode$2,
  fromJson: t_decode$2
};

function tt_encode(v) {
  return Js_dict.fromArray([[
                "tracker",
                Decco.optionToJson(t_encode, v.tracker)
              ]]);
}

function tt_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var tracker = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "tracker"), null));
  if (tracker.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              tracker: tracker._0
            }
          };
  }
  var e = tracker._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tracker" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function make(tracker) {
  return {
          tracker: tracker
        };
}

var codec$3 = [
  tt_encode,
  tt_decode
];

var Maybe = {
  tt_encode: tt_encode,
  tt_decode: tt_decode,
  make: make,
  codec: codec$3,
  toJson: tt_encode,
  fromJson: tt_decode
};

var Id;

var toJson = t_encode;

var fromJson = t_decode;

export {
  Id ,
  error_encode ,
  error_decode ,
  success_encode ,
  success_decode ,
  issue_encode ,
  issue_decode ,
  t_encode ,
  t_decode ,
  codec ,
  toJson ,
  fromJson ,
  $$Array ,
  start ,
  Interrupt ,
  Maybe ,
}
/* User-FeedSync Not a pure module */
